import { isBoolean } from 'util';
import * as _ from 'lodash';
export class ClientSettings {
  // Uses Component Structure Settings Only

  isVisible: boolean;
  tmp = {}
  oldArray = [
    'infoBarStyleData',
    'locationHomeViewAllUnitsData',
    'facilityInfoBannerData',
    'slideshowRowData',
    'howToRowData',
    'uhaulDealerBannerData',
    'footerData',
    'homePageFindUsComponentData',
    'contactFormData',
    'viewAllUnitsComponentData',
    'customPageHeroData',
    'aboutUsHeroData',
    'aboutUsMainSectionData',
    'viewAllReviewsHeaderData',
    'storeLocatorHeaderData',
    'storageCalculatorHeaderData',
    'storageTipsHeaderData',
    'contactHeaderData',
    'generalInfoHeaderData',
    'faqsHeaderData',
    'locationBarStyleData',
    'homePageFeaturesComponentData',
    'homePageButtonComponentData',
    'homePageMainIconsComponentData',
    'mainNavBarStyleData',
    'sizeGuideHeroData',
    'portalLoginData',
    'googleMapData'];


  tabBoxData = [
    { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
    { name: 'titleSize', type: 'string', size: 'small', text: 'Title Size' },
    { name: 'width', type: 'string', size: 'small', text: 'Width' },
    { name: 'color', type: 'color', size: 'small', text: 'Color' },
    { name: 'mobileColor', type: 'color', size: 'small', text: 'Mobile Color (leave blank if same as color)' },
    { name: 'tabLabelColor', type: 'color', size: 'small', text: 'Tab Label Color' },
    { name: 'mobileTabLabelColor', type: 'color', size: 'small', text: 'Mobile Tab Label Color - defaults to tab label color' },
    { name: 'background', type: 'color', size: 'small', text: 'Background' },
    { name: 'borderRadius', type: 'string', size: 'small', text: 'Border Radius' },
    { name: 'left', type: 'string', size: 'small', text: 'Left' },
    { name: 'top', type: 'string', size: 'small', text: 'Top' },
    { name: 'minHeight', type: 'string', size: 'small', text: 'Min Height' },
    { name: 'buttonWidth', type: 'string', size: 'small', text: 'Button Width' },
    { name: 'buttonFontSize', type: 'string', size: 'small', text: 'Button Font Size' },
    { name: 'padding', type: 'string', size: 'small', text: 'Padding' },
    { name: 'buttonPadding', type: 'string', size: 'small', text: 'Button Padding' },
    { name: 'buttonMarginTop', type: 'string', size: 'small', text: 'Margin Top' },
    { name: 'buttonBackground', type: 'color', size: 'small', text: 'Button Background' },
    { name: 'buttonColor', type: 'color', size: 'small', text: 'Button Color' },
    { name: 'phoneLinkColor', type: 'color', size: 'small', text: 'Phone Link Color' },
    { name: 'taglineFontStyle', type: 'string', size: 'small', text: 'Tagline Font Style' },
    { name: 'corporateHeroHeight', type: 'string', size: 'small', text: 'Corporate Hero Height' },
    { name: 'locationHeroHeight', type: 'string', size: 'small', text: 'Location Hero Height' },
    /*     { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
    { name: 'showEmail', type: 'boolean', size: 'small', text: 'Show Email Link' },
    { name: 'locationShowImagesOnV2', type: 'boolean', size: 'small', text: 'Show Images on Mobile for tab box v2' },
  ];

  locationTabBoxData = [
    { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
    { name: 'titleSize', type: 'string', size: 'small', text: 'Title Size' },
    { name: 'width', type: 'string', size: 'small', text: 'Width' },
    { name: 'color', type: 'color', size: 'small', text: 'Color' },
    { name: 'mobileColor', type: 'color', size: 'small', text: 'Mobile Color (leave blank if same as color)' },
    { name: 'tabLabelColor', type: 'color', size: 'small', text: 'Tab Label Color' },
    { name: 'mobileTabLabelColor', type: 'color', size: 'small', text: 'Mobile Tab Label Color - defaults to tab label color' },
    { name: 'background', type: 'color', size: 'small', text: 'Background' },
    { name: 'borderRadius', type: 'string', size: 'small', text: 'Border Radius' },
    { name: 'left', type: 'string', size: 'small', text: 'Left' },
    { name: 'top', type: 'string', size: 'small', text: 'Top' },
    { name: 'minHeight', type: 'string', size: 'small', text: 'Min Height' },
    { name: 'buttonWidth', type: 'string', size: 'small', text: 'Button Width' },
    { name: 'buttonFontSize', type: 'string', size: 'small', text: 'Button Font Size' },
    { name: 'padding', type: 'string', size: 'small', text: 'Padding' },
    { name: 'buttonPadding', type: 'string', size: 'small', text: 'Button Padding' },
    { name: 'buttonMarginTop', type: 'string', size: 'small', text: 'Margin Top' },
    { name: 'buttonBackground', type: 'color', size: 'small', text: 'Button Background' },
    { name: 'buttonColor', type: 'color', size: 'small', text: 'Button Color' },
    { name: 'phoneLinkColor', type: 'color', size: 'small', text: 'Phone Link Color' },
    { name: 'taglineFontStyle', type: 'string', size: 'small', text: 'Tagline Font Style' },
    { name: 'corporateHeroHeight', type: 'string', size: 'small', text: 'Corporate Hero Height' },
    { name: 'locationHeroHeight', type: 'string', size: 'small', text: 'Location Hero Height' },
    /* { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
    { name: 'showEmail', type: 'boolean', size: 'small', text: 'Show Email Link' },
    { name: 'locationShowImagesOnV2', type: 'boolean', size: 'small', text: 'Show Images on Mobile for tab box v2' },
  ];

  bigTitleData = [
    { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
    { name: 'titleSize', type: 'string', size: 'small', text: 'Title Size' },
    { name: 'titleWeight', type: 'string', size: 'small', text: 'Title Weight' },
    { name: 'titleShadow', type: 'string', size: 'small', text: 'Title Shadow' },
    { name: 'titleMargin', type: 'string', size: 'small', text: 'Title Margin' },
    { name: 'background', type: 'color', size: 'small', text: 'Background' },
    { name: 'minHeight', type: 'string', size: 'small', text: 'Min Height' },
    { name: 'buttonWidth', type: 'string', size: 'small', text: 'Button Width' },
    { name: 'buttonMaxWidth', type: 'string', size: 'small', text: 'Button Max Width' },
    { name: 'buttonFontSize', type: 'string', size: 'small', text: 'Button Font Size' },
    { name: 'padding', type: 'string', size: 'small', text: 'Padding' },
    { name: 'buttonPadding', type: 'string', size: 'small', text: 'Button Padding' },
    { name: 'buttonMargin', type: 'string', size: 'small', text: 'Button Margin' },
    { name: 'buttonBackground', type: 'color', size: 'small', text: 'Button Background' },
    { name: 'buttonColor', type: 'color', size: 'small', text: 'Button Color' },
    { name: 'phoneLinkColor', type: 'color', size: 'small', text: 'Phone Link Color' },
    /* { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
  ];

  /*   portalNavbarData = [
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Price Bubble Font Size' },
      { name: 'padding', type: 'string', size: 'small', text: 'Price Bubble Padding' },
      { name: 'padding', type: 'string', size: 'small', text: 'Price Bubble Padding' },
      { name: 'mattStyle', type: 'boolean', size: 'small', text: 'Matt style dropdowns?' },
    ]; */
  /*
    locationSlideoutData = {
      original: [
        { name: 'heightFromTop', type: 'string', size: 'small', text: 'Height From Top' },
        { name: 'innerHeightFromTop', type: 'string', size: 'small', text: 'Inner Height from Top' },
        { name: 'innerHeight', type: 'string', size: 'small', text: 'Inner Height' },
        { name: 'titleHeight', type: 'string', size: 'small', text: 'Slide Tab Height' },
        { name: 'titleBackground', type: 'color', size: 'small', text: 'Slide Tab Background Color' },
        { name: 'titleColor', type: 'color', size: 'small', text: 'Slide Tab Title Color' },
        { name: 'titleFontSize', type: 'string', size: 'small', text: 'Slide Tab Title Font Size' },
        { name: 'titleBorderRadius', type: 'string', size: 'small', text: 'Slide Tab Border Radius' },
        { name: 'locationTitleColor', type: 'color', size: 'small', text: 'Inner Title Color' },
        { name: 'locationTitleSize', type: 'string', size: 'small', text: 'Inner Title Font Size' },
        { name: 'locationFontColor', type: 'color', size: 'small', text: 'Inner Font Color' },
        { name: 'locationFontSize', type: 'string', size: 'small', text: 'Inner Font Size' },
        { name: 'locationLinkColor', type: 'color', size: 'small', text: 'Inner Link Color' },
        { name: 'locationButtonBackground', type: 'color', size: 'small', text: 'Button Background Color' },
        { name: 'innerWidth', type: 'string', size: 'small', text: 'Inner Width' },
        { name: 'border', type: 'string', size: 'small', text: 'Inner Border' },
        { name: 'titleText', type: 'string', size: 'small', text: 'Inner Title Text' },
        { name: 'leftButtonText', type: 'string', size: 'small', text: 'Left Button Text' },
        { name: 'rightButtonText', type: 'string', size: 'small', text: 'Right Button Text' },
        { name: 'isRightSide', type: 'boolean', size: 'small', text: 'Show on right side of page instead?' },
        { name: 'useMapComponentInstead', type: 'boolean', size: 'small', text: 'Show map component inside instead?' },
      ]
    }; */

  sizeGuideRentReserveButtonData = [
    { name: 'color', type: 'color', size: 'small', text: 'Button Color' },
    { name: 'rentBackground', type: 'color', size: 'small', text: 'Button Background' },
    { name: 'padding', type: 'string', size: 'small', text: 'Padding' },
    { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
    { name: 'minWidth', type: 'string', size: 'small', text: 'Min Width' },
  ];


  // Uses Component Structure

  switchLocationComponentData = {
    original: [
      { name: 'imageHeight', text: 'Image Height', type: 'string', size: 'small' },
      { name: 'titleFontSize', text: 'Title Font Size', type: 'string', size: 'small' },
      { name: 'titleFontWeight', text: 'Title Font Weight', type: 'string', size: 'small' },
      { name: 'titleFontColor', text: 'Title Font Color', type: 'color', size: 'small' },
      { name: 'phoneColor', text: 'Phone Color', type: 'color', size: 'small' },
      { name: 'phoneSize', text: 'Phone Size', type: 'string', size: 'small' },
      { name: 'buttonFontSize', text: 'Button Font Size', type: 'string', size: 'small' },
      { name: 'buttonPadding', text: 'Button Padding', type: 'string', size: 'small' },
      { name: 'buttonMarginTop', text: 'Button Margin Top', type: 'string', size: 'small' },
      { name: 'buttonColor', text: 'Button Color', type: 'color', size: 'small' },
      { name: 'buttonWidth', text: 'Button Width', type: 'string', size: 'small' },
      { name: 'buttonBackground', text: 'Button Background', type: 'color', size: 'small' },
      { name: 'background', text: 'Card Background', type: 'color', size: 'small' },
    ],
    cards: [
      { name: 'imageHeight', text: 'Image Height', type: 'string', size: 'small' },
      { name: 'titleFontSize', text: 'Title Font Size', type: 'string', size: 'small' },
      { name: 'titleFontWeight', text: 'Title Font Weight', type: 'string', size: 'small' },
      { name: 'titleFontColor', text: 'Title Font Color', type: 'color', size: 'small' },
      { name: 'phoneColor', text: 'Phone Color', type: 'color', size: 'small' },
      { name: 'phoneSize', text: 'Phone Size', type: 'string', size: 'small' },
      { name: 'buttonFontSize', text: 'Button Font Size', type: 'string', size: 'small' },
      { name: 'buttonPadding', text: 'Button Padding', type: 'string', size: 'small' },
      { name: 'buttonMarginTop', text: 'Button Margin Top', type: 'string', size: 'small' },
      { name: 'buttonColor', text: 'Button Color', type: 'color', size: 'small' },
      { name: 'buttonWidth', text: 'Button Width', type: 'string', size: 'small' },
      { name: 'buttonBackground', text: 'Button Background', type: 'color', size: 'small' },
      { name: 'background', text: 'Card Background', type: 'color', size: 'small' },
    ],
    units: [
      /*  { name: 'imageHeight', text: 'Image Height', type: 'string', size: 'small' },
       { name: 'titleFontSize', text: 'Title Font Size', type: 'string', size: 'small' },
       { name: 'titleFontWeight', text: 'Title Font Weight', type: 'string', size: 'small' },
       { name: 'titleFontColor', text: 'Title Font Color', type: 'color', size: 'small' },
       { name: 'phoneColor', text: 'Phone Color', type: 'color', size: 'small' },
       { name: 'phoneSize', text: 'Phone Size', type: 'string', size: 'small' },
       { name: 'buttonFontSize', text: 'Button Font Size', type: 'string', size: 'small' },
       { name: 'buttonPadding', text: 'Button Padding', type: 'string', size: 'small' },
       { name: 'buttonMarginTop', text: 'Button Margin Top', type: 'string', size: 'small' },
       { name: 'buttonColor', text: 'Button Color', type: 'color', size: 'small' },
       { name: 'buttonWidth', text: 'Button Width', type: 'string', size: 'small' },
       { name: 'buttonBackground', text: 'Button Background', type: 'color', size: 'small' },
       { name: 'background', text: 'Card Background', type: 'color', size: 'small' }, */
    ],
    map: [
      { name: 'mapZoom', text: 'Map Zoom (Override Automatic Zoom)', type: 'string', size: 'small' }
    ],
    states: [
      { name: 'background', text: 'Card Background', type: 'color', size: 'small' },
      { name: 'noneSelectedTitle', text: 'None Selected Title', type: 'string', size: 'full' },
      { name: 'noneSelectedText', text: 'None Selected Text', type: 'string', size: 'full' },
      { name: 'noneSelectedImage', text: 'None Selected Image', type: 'string', size: 'full' },
      { name: 'titleFontColor', text: 'Card Title Font Color', type: 'color', size: 'small' },
      { name: 'phoneColor', text: 'Card Font Color', type: 'color', size: 'small' },
      { name: 'buttonColor', text: 'State Font Color', type: 'color', size: 'small' },
      { name: 'isClickableStates', text: 'Show Clickable States', type: 'boolean', size: 'full' },
    ]
  };

  infoBarStyleData = {
    /*     logoCentered: [
          { name: 'logoCenteredPhoneIcon', type: 'string', size: 'full', text: 'Phone Icon URL' },
          { name: 'logoCenteredMapIcon', type: 'string', size: 'full', text: 'Map Icon URL' },
          { name: 'height', type: 'string', size: 'small', text: 'Height' },
          { name: 'logoHeight', type: 'string', size: 'small', text: 'Logo Height' },
          { name: 'mobileLogoHeight', type: 'string', size: 'small', text: 'Mobile Logo Height' },
          { name: 'marginTop', type: 'string', size: 'small', text: 'Margin Top' },
          { name: 'iconHeight', type: 'string', size: 'small', text: 'Icon Height' },
          { name: 'iconWidth', type: 'string', size: 'small', text: 'Icon Width' },
          { name: 'background', type: 'color', size: 'small', text: 'Background' },
          { name: 'color', type: 'color', size: 'small', text: 'Color' },
          { name: 'hoverColor', type: 'color', size: 'small', text: 'Hover Color' },
          { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
          { name: 'logoMarginTop', type: 'string', size: 'small', text: 'Logo Margin Top' },
          { name: 'hideClientEmail', type: 'boolean', size: 'small', text: 'Show "Email Us" in place of email' }
        ], */
    original: [
      //{ name: 'height', type: 'string', size: 'small', text: 'Height' },
      // { name: 'mobileHeight', type: 'string', size: 'small', text: 'Mobile Height' },
      { name: 'linkText', type: 'string', size: 'small', text: 'Link Text' },
      { name: 'linkIcon', type: 'string', size: 'small', text: 'Material Icon Name' },
      { name: 'linkRoute', type: 'selection', size: 'small', text: 'Route to link to', options: [{ value: '/customer-portal/login', label: 'Pay Bill' }, { value: '/units', label: 'Units Page' }] },
      // { name: 'background', type: 'color', size: 'small', text: 'Background' },
      // { name: 'color', type: 'color', size: 'small', text: 'Color' },
      // { name: 'hoverColor', type: 'color', size: 'small', text: 'Hover Color' },
      { name: 'hideClientEmail', type: 'boolean', size: 'small', text: 'Show "Email Us" in place of email' }
    ],
    /*     phoneRight: [
          { name: 'height', type: 'string', size: 'small', text: 'Height' },
          { name: 'mobileHeight', type: 'string', size: 'small', text: 'Mobile Height' },
          { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
          { name: 'background', type: 'color', size: 'small', text: 'Background' },
          { name: 'color', type: 'color', size: 'small', text: 'Color' },
          { name: 'hoverColor', type: 'color', size: 'small', text: 'Hover Color' },
          { name: 'showAllLocations', type: 'boolean', size: 'small', text: 'If Multiple Locations show all phone numbers (true) show only selected (false)' },
          { name: 'hideClientEmail', type: 'boolean', size: 'small', text: 'Show "Email Us" in place of email' }
        ] */
  };
  infoBarStyleDataOld = {
    original: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'hoverColor', type: 'color', size: 'small', text: 'Hover Color' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'mobileHeight', type: 'string', size: 'small', text: 'Mobile Height' },
    ]
  };
  portableQuoteBarData = {
    original: [
      { name: 'title', type: 'string', size: 'full', text: 'Title Text' },
      { name: 'homepageQuoteBlurb', type: 'textarea', text: 'Blurb Text above Quote Form on Homepage' },
      { name: 'quoteBlurb', type: 'textarea', text: 'Blurb Text above Quote Form' },
      { name: 'blurb', type: 'textarea', text: 'Blurb Text above first rental step' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
    ]
  };

  separatorBarData = {
    original: [
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'textFontSize', type: 'string', size: 'small', text: 'Text Font Size' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'hideBottomTextOnMobile', type: 'boolean', size: 'full', text: 'Hide bottom text on mobile' },
    ]
  };

  /**
   *   locationHomeViewAllUnitsData = {
    lazyLoadUnits: false,
    small: false,
    initialSortSize: "sm",
    titleText: "Available Storage Units",
    titleFontSize: '30px',
    titleMargin: '30px 0px 30px 0px',
    titleTextAlign: 'center',
    titleColor: '#636973',
    breakPoint: "sm",
    smallSettingsFilterTitleFullText: false,
    smallSettingsShowFilterIcons: false,
    wrapperBg: '#fff',
    wrapperPaddingBottom: '50px',
    filterChipColor: '#fff',
    filterChipBg: 'rgb(244, 189, 40)',
    filterChipThreshold: 5,
    filterBackground: '#efefef',
    filterIconFontSize: '30px',
    filterShowIcons: true,
    amenitiesIconWidth: '50px',
    amenitiesType: 'icon',
    amenitiesIconMargin: '5px 5px 0 0',
    priceShowBorder: false,
    priceFontSize: '28px',
    priceOldRateColor: '#94949B',
    priceOldRateFontSize: '22px',
    priceDiscountFontSize: '18px'
  }
   */

  locationHomeViewAllUnitsData = {
    original: [
      /*  { name: 'lazyLoadUnits', type: 'boolean', size: 'small', text: 'Lazy Load Units' }, */
      { name: 'small', type: 'boolean', size: 'small', text: 'Always use mobile styles' },
      { name: 'showFacilityName', type: 'boolean', size: 'small', text: 'Show Facility Name by Location Name' },
      /* { name: 'showLocationInfoMapCard', type: 'boolean', size: 'small', text: 'Show Info Map Card to Right' },
      { name: 'priceShowBorder', type: 'boolean', size: 'small', text: 'Show Border around Price' },*/
      { name: 'filterShowIcons', type: 'boolean', size: 'small', text: 'Filter Show Icons' },
      { name: 'smallSettingsFilterTitleFullText', type: 'boolean', size: 'small', text: 'Show Full Filter Title on Mobile' },
      { name: 'titleText', type: 'string', size: 'full', text: 'Title Text' },
      /* { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'titleMargin', type: 'string', size: 'small', text: 'Title Margin' },
      { name: 'titleTextAlign', type: 'string', size: 'small', text: 'Title Text Align' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' }, */
      { name: 'breakPoint', type: 'string', size: 'small', text: 'Breakpoint (sm or md)' },
      /*  { name: 'wrapperBg', type: 'color', size: 'small', text: 'Background' },
       { name: 'wrapperPaddingBottom', type: 'string', size: 'small', text: 'Padding Bottom' },
      { name: 'filterBackground', type: 'color', size: 'small', text: 'Filter BG' },
        { name: 'filterIconFontSize', type: 'color', size: 'small', text: 'Filter Icon Font Size' },
       { name: 'filterChipColor', type: 'color', size: 'small', text: 'Filter Urgency Color' },*/
      { name: 'filterChipBg', type: 'color', size: 'small', text: 'Filter Urgency BG' },
      { name: 'filterChipThreshold', type: 'color', size: 'small', text: 'Filter Urgency Threshold' },
      { name: 'amenitiesType', type: 'string', size: 'small', text: 'Amenities type (icon or text)' },
      /*    { name: 'amenitiesIconWidth', type: 'string', size: 'small', text: 'Amenities Icons Width' },
         { name: 'amenitiesIconMargin', type: 'string', size: 'small', text: 'Amenities Icon Margin' },
         { name: 'priceFontSize', type: 'string', size: 'small', text: 'Price font size' },
         { name: 'priceOldRateFontSize', type: 'string', size: 'small', text: 'Price Font Size' },
         { name: 'priceDiscountFontSize', type: 'string', size: 'small', text: 'Discount Price Font Size' }, */
      { name: 'priceOldRateColor', type: 'color', size: 'small', text: 'Discount Rate Color' },
      { name: 'initialSortSize', type: 'string', size: 'small', text: 'Initial Sort Size (sm, md, park etc)' },
    ]
  };
  locationHomeViewAllUnitsDataOld = {
    original: [
      { name: 'lazyLoadUnits', type: 'boolean', size: 'small', text: 'Lazy Load Units' },
      { name: 'showLocationInfoMapCard', type: 'boolean', size: 'small', text: 'Show Info Map Card to Right' },
      { name: 'priceShowBorder', type: 'boolean', size: 'small', text: 'Show Border around Price' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'titleMargin', type: 'string', size: 'small', text: 'Title Margin' },
      { name: 'titleTextAlign', type: 'string', size: 'small', text: 'Title Text Align' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'wrapperBg', type: 'color', size: 'small', text: 'Background' },
      { name: 'wrapperPaddingBottom', type: 'string', size: 'small', text: 'Padding Bottom' },
      { name: 'filterBackground', type: 'color', size: 'small', text: 'Filter BG' },
      { name: 'filterIconFontSize', type: 'color', size: 'small', text: 'Filter Icon Font Size' },
      { name: 'filterChipColor', type: 'color', size: 'small', text: 'Filter Urgency Color' },
      { name: 'amenitiesIconWidth', type: 'string', size: 'small', text: 'Amenities Icons Width' },
      { name: 'amenitiesIconMargin', type: 'string', size: 'small', text: 'Amenities Icon Margin' },
      { name: 'priceFontSize', type: 'string', size: 'small', text: 'Price font size' },
      { name: 'priceOldRateFontSize', type: 'string', size: 'small', text: 'Price Font Size' },
      { name: 'priceDiscountFontSize', type: 'string', size: 'small', text: 'Discount Price Font Size' },

    ]
  };

  viewAllUnitsComponentHeaderTypeData = {
    locationBox: [
      { name: 'sidebar', type: 'selection', size: 'small', text: 'Show Sidebar', options: [{ value: 'show', label: 'Always Show' }, { value: 'hideOnMobile', label: 'Hide on Mobile' }, { value: 'hidden', label: 'Always Hide' }] },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'margin', type: 'string', size: 'small', text: 'Margin' },
      { name: 'fontColor', type: 'color', size: 'small', text: 'Font Color' },
      /* { name: 'showClientNameInstead', type: 'boolean', size: 'small', text: 'Show client name instead of location name' }, */
      { name: 'cardBehindPicture', type: 'boolean', size: 'small', text: 'Show card behind image' },
      { name: 'subheading', type: 'string', size: 'small', text: 'Subheading' }
    ],
    locationBoxV2: [
      { name: 'sidebar', type: 'selection', size: 'small', text: 'Show Sidebar', options: [{ value: 'show', label: 'Always Show' }, { value: 'hideOnMobile', label: 'Hide on Mobile' }, { value: 'hidden', label: 'Always Hide' }, { value: 'alwaysTabs', label: 'Always Tabs' }] },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'subheading', type: 'string', size: 'small', text: 'Subheading' },
      /*       { name: 'hideClientName', type: 'boolean', size: 'small', text: 'Hide Client name' } */
    ],
    locationBoxV3: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'subheading', type: 'string', size: 'small', text: 'Subheading' },
      { name: 'bottomBorder', type: 'string', size: 'small', text: 'City Bottom Border (ie: 3px dashed #668954)' },
      /*    { name: 'hideClientName', type: 'boolean', size: 'small', text: 'Hide Client name' } */
    ]
  };

  htmlRowData = {};

  locationSeparatorBarData = {
    original: [
      { name: 'titleMarginTop', type: 'string', size: 'small', text: 'Title Margin Top' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'textMarginTop', type: 'string', size: 'small', text: 'Text Margin Top' },
      { name: 'textFontSize', type: 'string', size: 'small', text: 'Text Font Size' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
    ]
  };

  locationBannerData = {
    original: [
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'padding', type: 'string', size: 'small', text: 'Padding' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'showSeparator', type: 'boolean', size: 'small', text: 'Show Separator' },
      { name: 'showPictures', type: 'boolean', size: 'small', text: 'Show Location Pictures' },
      { name: 'separatorColor', type: 'color', size: 'small', text: 'Separator Color' },
      { name: 'lineColor', type: 'color', size: 'small', text: 'Line Color' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'title', type: 'string', size: 'small', text: 'Title Text' },
      { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle Text' },
      { name: 'locationNameColor', type: 'color', size: 'small', text: 'Location Name Color' },
      { name: 'placement', type: 'selection', size: 'small', text: 'Placement', options: [{ value: 'aboveFeatures', label: 'Above Features' }, { value: 'belowFeatures', label: 'Below Features' }] },
      { name: 'linkToUnitsPage', type: 'boolean', size: 'full', text: 'Link to rates page instead of location home' },
      { name: 'showGroupBlurbs', type: 'boolean', size: 'full', text: 'Show group blurbs under each title' },
    ],
    state: [
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'padding', type: 'string', size: 'small', text: 'Padding' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'lineColor', type: 'color', size: 'small', text: 'Line Color' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'locationNameColor', type: 'color', size: 'small', text: 'Location Name Color' },
      { name: 'locationBoxColor', type: 'color', size: 'small', text: 'Location Box Background Color' },
      { name: 'placement', type: 'selection', size: 'small', text: 'Placement', options: [{ value: 'aboveFeatures', label: 'Above Features' }, { value: 'belowFeatures', label: 'Below Features' }] },
      { name: 'linkToUnitsPage', type: 'boolean', size: 'full', text: 'Link to rates page instead of location home' },
    ],
    insights: [
      { name: 'title', type: 'string', size: 'small', text: 'Title Text' }
    ]
  };

  facilityInfoBannerData = {
    original: [
      /* { name: 'showAccent', type: 'boolean', size: 'small', text: 'Show accent behind image?' },
      { name: 'showCta', type: 'boolean', size: 'small', text: 'Show CTA Button?' }, */
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      /*  { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
       { name: 'onlyShowOnCorporateHome', type: 'boolean', size: 'small', text: 'Only Show on Corporate Home' } */
    ],
    version2: [
      { name: 'backgroundLeft', type: 'color', size: 'small', text: 'Background Card Side' },
      { name: 'titleRightColor', type: 'color', size: 'small', text: 'Card Heading Color' },
      { name: 'lineColor', type: 'color', size: 'small', text: 'Card Heading Line Color' },
      { name: 'backgroundRight', type: 'color', size: 'small', text: 'Background Text Side' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Text Title Color' },
      { name: 'centerLine', type: 'selection', size: 'small', text: 'Background Split', options: [{ value: 'centerLine', label: '50%/50%' }, { value: 'offCenter', label: '55%/45%' }] },
      { name: 'layout', type: 'selection', size: 'small', text: 'Layout', options: [{ value: 'imageRight', label: 'Default' }, { value: 'imageLeft', label: 'Reverse sides' }] },
      { name: 'breakpoint', type: 'selection', size: 'small', text: 'Break Size', options: [{ value: 'tablet', label: 'Tablet' }, { value: 'cell', label: 'Cell' }] },
    ]
  };
  facilityInfoBannerDataOld = {
    original: [
      { name: 'showAccent', type: 'boolean', size: 'small', text: 'Show accent behind image?' },
      { name: 'showCta', type: 'boolean', size: 'small', text: 'Show CTA Button?' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'onlyShowOnCorporateHome', type: 'boolean', size: 'small', text: 'Only Show on Corporate Home' }
    ]
  };

  slideshowRowData = {
    original: [
      /* { name: 'titleSize', type: 'string', size: 'small', text: 'Title Size' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'autoplaySlides', type: 'boolean', size: 'small', text: 'Autoplay Slides' }, */
      { name: 'fullPageWidth', type: 'boolean', size: 'small', text: 'Full Page Width' },
      { name: 'showSideArticle', type: 'boolean', size: 'small', text: 'Show Side Article' },
      { name: 'sideArticleOnLeft', type: 'boolean', size: 'small', text: 'Left Side Article' },
      /*       { name: 'articleCard', type: 'boolean', size: 'small', text: 'Card behind Article' }, */
      { name: 'slideHeight', type: 'string', size: 'small', text: 'Slide Height' },
      { name: 'backgroundColor', type: 'color', size: 'small', text: 'Background Color' },
      /*  { name: 'articleCardBGColor', type: 'color', size: 'small', text: 'Article Card Background Color' },
       { name: 'articleTextColor', type: 'color', size: 'small', text: 'Article Text Color' }, */
      { name: 'slideBackgroundSize', type: 'selection', size: 'small', text: 'Slide Background Size', options: [{ value: 'cover', label: 'cover' }, { value: 'contain', label: 'contain' }, { value: 'auto', label: 'auto' }] },
    ]
  };
  slideshowRowDataOld = {
    original: [
      { name: 'titleSize', type: 'string', size: 'small', text: 'Title Size' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'autoplaySlides', type: 'boolean', size: 'small', text: 'Autoplay Slides' },
      { name: 'articleCard', type: 'boolean', size: 'small', text: 'Card behind Article' },
      { name: 'articleCardBGColor', type: 'color', size: 'small', text: 'Article Card Background Color' },
      { name: 'articleTextColor', type: 'color', size: 'small', text: 'Article Text Color' },
    ]
  };

  howToRowData = {
    original: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'breakSmall', type: 'boolean', size: 'full', text: 'Break on small size' },
      /*       { name: 'cardBackground', type: 'color', size: 'small', text: 'Card Background' },
            { name: 'cardTextColor', type: 'color', size: 'small', text: 'Card Text Color' },
            { name: 'cardTitleFontSize', type: 'string', size: 'small', text: 'Card Title Font Size' },
            { name: 'cardFontSize', type: 'string', size: 'small', text: 'Card Font Size' },
      */
    ]
  }
  howToRowDataOld = {
    original: [
      { name: 'cardBackground', type: 'color', size: 'small', text: 'Card Background' },
      { name: 'cardTextColor', type: 'color', size: 'small', text: 'Card Text Color' },
      { name: 'cardTitleFontSize', type: 'string', size: 'small', text: 'Card Title Font Size' },
      { name: 'cardFontSize', type: 'string', size: 'small', text: 'Card Font Size' },
    ]
  }

  uhaulDealerBannerData = {
    original: [
      /* { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'padding', type: 'string', size: 'small', text: 'Padding' }, */
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      /*    { name: 'placement', type: 'selection', size: 'small', text: 'Placement', options: [{ value: 'aboveFooter', label: 'Above Footer' }, { value: 'belowMainIcons', label: 'Below Main (Primary) Icons' }] }, */
      { name: 'uhaulLink', type: 'string', size: 'small', text: 'Uhaul Link' },
    ]
  };
  uhaulDealerBannerDataOld = {
    original: [
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'padding', type: 'string', size: 'small', text: 'Padding' },
      { name: 'placement', type: 'selection', size: 'small', text: 'Placement', options: [{ value: 'aboveFooter', label: 'Above Footer' }, { value: 'belowMainIcons', label: 'Below Main (Primary) Icons' }] },
    ]
  };

  locationsNearYouBannerData = {
    original: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'cardColor', type: 'color', size: 'small', text: 'Card Color' },
      { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
      { name: 'closestStoreRibbonColor', type: 'color', size: 'small', text: 'Closest Store Ribbon Color' },
      { name: 'closestStoreRibbonBackgroundColor', type: 'color', size: 'small', text: 'Closest Store Ribbon Background Color' },
      { name: 'hideQuoteForm', type: 'boolean', size: 'full', text: 'Hide Request a Quote Form' },
    ]
  }

  footerData = {
    original: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'trademarkBackground', type: 'color', size: 'small', text: 'Trademark Background' },
      { name: 'trademarkColor', type: 'color', size: 'small', text: 'Trademark Color' },
      { name: 'height', type: 'string', size: 'small', text: 'Min Height' },
      { name: 'trademarkHeight', type: 'string', size: 'small', text: 'Trademark Min Height' },
      { name: 'phoneFontSize', type: 'string', size: 'small', text: 'Phone Font Size' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
      { name: 'showDropdownLinks', type: 'boolean', size: 'full', text: 'Show links from dropdowns under Quick Links' },
      /* { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
      { name: 'showFacilityNameAndLocation', type: 'boolean', size: 'small', text: 'Show Facility Name With Location' },
      { name: 'showBottomText', type: 'boolean', size: 'small', text: 'Add text to bottom' },
      { name: 'bottomText', type: 'string', size: 'small', text: 'Bottom Text' },
      { name: 'showCta', type: 'boolean', size: 'full', text: 'Show CTA button?' },
      { name: 'ctaPlacement', type: 'selection', size: 'full', text: 'CTA Placement', options: [{ label: 'Under Quick Links', value: 'underQuickLinks' }, { label: 'Under Contact Info', value: 'underContactInfo' }, { label: 'Under Locations/Hours (Right Side)', value: 'underRightSide' }] },
      { name: 'ctaLink', type: 'string', size: 'full', text: 'CTA Link (must be routerlink)' },
      { name: 'ctaText', type: 'string', size: 'small', text: 'CTA Text' },
      { name: 'ctaColor', type: 'color', size: 'small', text: 'CTA Color' },
      { name: 'ctaBackgroundColor', type: 'color', size: 'small', text: 'CTA Background Color' },
      { name: 'subheading', type: 'string', size: 'small', text: 'Subheading' }
    ],
    withForm: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'cardColor', type: 'color', size: 'small', text: 'Card Color' },
      { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
      { name: 'closestStoreRibbonColor', type: 'color', size: 'small', text: 'Closest Store Ribbon Color' },
      { name: 'closestStoreRibbonBackgroundColor', type: 'color', size: 'small', text: 'Closest Store Ribbon Background Color' },
      { name: 'hideQuoteForm', type: 'boolean', size: 'full', text: 'Hide Request a Quote Form' },
      { name: 'trademarkBackground', type: 'color', size: 'small', text: 'Trademark Background' },
      { name: 'trademarkColor', type: 'color', size: 'small', text: 'Trademark Color' },
      { name: 'trademarkHeight', type: 'string', size: 'small', text: 'Trademark Min Height' },
      { name: 'subheading', type: 'string', size: 'small', text: 'Subheading' }
    ],
    small: [
      /*       { name: 'background', type: 'color', size: 'small', text: 'Background' },
            { name: 'color', type: 'color', size: 'small', text: 'Color' },
            { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' }, */
      { name: 'altLogoUrl', type: 'string', size: 'small', text: 'Alt Logo URL' },
    ]
  };
  footerDataOld = {
    small: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
    ]
  }

  associationsData = {
    original: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'logoMaxHeight', type: 'string', size: 'small', text: 'Logo Max Height' },
      { name: 'logoMaxWidth', type: 'string', size: 'small', text: 'Logo Max Width' },
      { name: 'placement', type: 'selection', size: 'small', text: 'Placement', options: [{ label: 'Above Footer', value: 'aboveFooter' }, { label: 'Below Footer', value: 'belowFooter' }] },
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle' }
    ]
  };

  homePageFindUsComponentData = {
    original: [
      /*  { name: 'height', type: 'string', size: 'small', text: 'Height' },
       { name: 'background', type: 'color', size: 'small', text: 'Background' },
       { name: 'color', type: 'color', size: 'small', text: 'Color' },
       { name: 'title', type: 'string', size: 'small', text: 'Title' },
       { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle' },
       { name: 'showNameInstead', type: 'boolean', size: 'small', text: 'Show name instead of "Us"' }, */
    ]
  };
  homePageFindUsComponentDataOld = {
    original: [
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle' },
      { name: 'showNameInstead', type: 'boolean', size: 'small', text: 'Show name instead of "Us"' },
    ]
  };

  contactFormData = {
    original: [
      { name: 'phoneAddressFontSize', type: 'string', size: 'small', text: 'Phone and Email Font Size' },
      /*  { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
      { name: 'showPhoneNumber', type: 'boolean', size: 'small', text: 'Show Phone Number Field' },
      { name: 'showUnitNumber', type: 'boolean', size: 'small', text: 'Show Unit Number Field' },
      { name: 'contactCtaBlurb', type: 'string', size: 'small', text: 'Contact CTA Blurb' },
      { name: 'subtitleFontSize', type: 'string', size: 'small', text: 'Subtitle Font Size' },
      { name: 'showReviewLink', type: 'boolean', size: 'small', text: 'Show Review Link' },
    ],
    originalV2: [
      { name: 'phoneAddressFontSize', type: 'string', size: 'small', text: 'Phone and Email Font Size' },
      /*  { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
      { name: 'showPhoneNumber', type: 'boolean', size: 'small', text: 'Show Phone Number Field' },
      { name: 'showUnitNumber', type: 'boolean', size: 'small', text: 'Show Unit Number Field' },
      { name: 'contactCtaBlurb', type: 'string', size: 'small', text: 'Contact CTA Blurb' },
      { name: 'subtitleFontSize', type: 'string', size: 'small', text: 'Subtitle Font Size' },
      { name: 'showReviewLink', type: 'boolean', size: 'small', text: 'Show Review Link' },
    ],
    clean: [
      /*       { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
      { name: 'showPhoneNumber', type: 'boolean', size: 'small', text: 'Show Phone Number Field' },
      { name: 'showUnitNumber', type: 'boolean', size: 'small', text: 'Show Unit Number Field' },
      { name: 'useDefaultLocationAsHome', type: 'boolean', size: 'small', text: 'Show default location info only for home office' },
      { name: 'contactCtaBlurb', type: 'string', size: 'small', text: 'Contact CTA Blurb' },
      /* { name: 'titleBackground', text: 'Title/Subtitle Background', type: 'color', size: 'small' },
      { name: 'cleanTitleColor', text: 'Title color', type: 'color', size: 'small' },
      { name: 'boxHeaderColor', text: 'Contact Box Header color', type: 'color', size: 'small' },
      { name: 'boxTextColor', text: 'Contact Box Text color', type: 'color', size: 'small' },
      { name: 'cleanIconColor', text: 'Contact Box Icon color', type: 'color', size: 'small' },
      { name: 'cleanLinkColor', text: 'Link color', type: 'color', size: 'small' }, */
      { name: 'cleanTitle', type: 'string', size: 'small', text: 'Title' }
    ],
    floatOverMap: [
      { name: 'showPhoneNumber', type: 'boolean', size: 'small', text: 'Show Phone Number Field' },
      { name: 'showUnitNumber', type: 'boolean', size: 'small', text: 'Show Unit Number Field' },
      { name: 'contactCtaBlurb', type: 'string', size: 'small', text: 'Contact CTA Blurb' },
      /* { name: 'subtitleFontSize', type: 'string', size: 'small', text: 'Subtitle Font Size' },
      { name: 'formBackground', text: 'Form background', type: 'color', size: 'small' },
      { name: 'titleColor', text: 'Title color', type: 'color', size: 'small' },
      { name: 'subtitleColor', text: 'Subitle color', type: 'color', size: 'small' },
      { name: 'textColor', text: 'Text color', type: 'color', size: 'small' },
      { name: 'linkColor', text: 'Link color', type: 'color', size: 'small' },
      { name: 'blurbColor', text: 'Blurb color', type: 'color', size: 'small' }, */
      { name: 'mapZoom', text: 'Map Zoom', type: 'string', size: 'small' },
      { name: 'windowBorderRadius', text: 'Map marker window border radius, if any', type: 'string', size: 'small' },
      { name: 'windowPlacement', type: 'selection', size: 'small', text: 'Map marker window placement', options: [{ value: 'right', label: 'Right' }, { value: 'top', label: 'Top' }] },
    ],
  };
  contactFormDataOld = {
    clean: [
      { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' },
      { name: 'titleBackground', text: 'Title/Subtitle Background', type: 'color', size: 'small' },
      { name: 'cleanTitleColor', text: 'Title color', type: 'color', size: 'small' },
      { name: 'boxHeaderColor', text: 'Contact Box Header color', type: 'color', size: 'small' },
      { name: 'boxTextColor', text: 'Contact Box Text color', type: 'color', size: 'small' },
      { name: 'cleanIconColor', text: 'Contact Box Icon color', type: 'color', size: 'small' },
      { name: 'cleanLinkColor', text: 'Link color', type: 'color', size: 'small' },

    ],
    floatOverMap: [

      { name: 'subtitleFontSize', type: 'string', size: 'small', text: 'Subtitle Font Size' },
      { name: 'formBackground', text: 'Form background', type: 'color', size: 'small' },
      { name: 'titleColor', text: 'Title color', type: 'color', size: 'small' },
      { name: 'subtitleColor', text: 'Subitle color', type: 'color', size: 'small' },
      { name: 'textColor', text: 'Text color', type: 'color', size: 'small' },
      { name: 'linkColor', text: 'Link color', type: 'color', size: 'small' },
      { name: 'blurbColor', text: 'Blurb color', type: 'color', size: 'small' },

    ],
  }

  viewAllUnitsComponentData = {
    original: [
      { name: 'border', text: 'border', type: 'string', size: 'small' },
      { name: 'catButtonsBackground', text: 'Cat Buttons Background', type: 'color', size: 'small' },
      { name: 'catButtonsColor', text: 'Cat Buttons Color', type: 'color', size: 'small' },
      { name: 'rentButtonBackground', text: 'Rent Button Background', type: 'color', size: 'small' },
      { name: 'rentButtonColor', text: 'Rent Button Color', type: 'color', size: 'small' },
      { name: 'reserveButtonBackground', text: 'Reserve button Background', type: 'color', size: 'small' },
      { name: 'reserveButtonColor', text: 'Reserve Button Color', type: 'color', size: 'small' },
      { name: 'viewUnitsChipBackground', text: 'View Units Chip BG', type: 'color', size: 'small' },
      { name: 'viewUnitsChipColor', text: 'View Units Chip Color', type: 'color', size: 'small' },
      { name: 'discountColor', text: 'Discount Color', type: 'color', size: 'small' },
      { name: 'rentUnitFontSize', text: 'Rent Unit Font Size', type: 'string', size: 'small' },
      { name: 'reserveUnitFontSize', text: 'Reserve Unit Font Size', type: 'string', size: 'small' },
      { name: 'rentButtonNoShadow', text: 'Remove rent button shadow', type: 'boolean', size: 'small' },
      { name: 'hideRentReserveBoxes', text: 'Hide Rent and Reserve Boxes', type: 'boolean', size: 'small' },
      { name: 'showLocationBox', text: 'Show Location Box', type: 'boolean', size: 'small' },
      { name: 'locationBoxHeaderColor', text: 'Location Box Header Color', type: 'color', size: 'small' },
      { name: 'locationBoxSubheaderColor', text: 'Location Box Subheader Color', type: 'color', size: 'small' },
      { name: 'locationBoxPhoneLinkColor', text: 'Location Box Phone Link Color', type: 'color', size: 'small' },
      { name: 'locationBoxUseSlideshow', text: 'Location Box Slideshow instead of single image', type: 'boolean', size: 'full' },
      { name: 'spaceInsteadOfUnit', text: 'Says Space instead of Unit', type: 'boolean', size: 'small' },
    ],
    modern: [
      { name: 'discountColor', text: 'Discount Color', type: 'color', size: 'small' },
      { name: 'locationBoxPhoneLinkColor', text: 'Location Box Phone Link Color', type: 'color', size: 'small' },
      { name: 'locationBoxHeaderColor', text: 'Location Box Header Color', type: 'color', size: 'small' },
      { name: 'locationBoxSubheaderColor', text: 'Location Box Subheader Color', type: 'color', size: 'small' },
      { name: 'locationBoxUseSlideshow', text: 'Location Box Slideshow instead of single image', type: 'boolean', size: 'full' },
      { name: 'viewUnitsChipBackground', text: 'View Units Chip BG', type: 'color', size: 'small' },
      { name: 'viewUnitsChipColor', text: 'View Units Chip Color', type: 'color', size: 'small' },

      { name: 'lazyLoadUnits', type: 'boolean', size: 'small', text: 'Lazy Load Units' },
      { name: 'small', type: 'boolean', size: 'small', text: 'Always use mobile styles' },
      { name: 'priceShowBorder', type: 'boolean', size: 'small', text: 'Show Border around Price' },
      { name: 'filterShowIcons', type: 'boolean', size: 'small', text: 'Filter Show Icons' },
      { name: 'smallSettingsFilterTitleFullText', type: 'boolean', size: 'small', text: 'Show Full Filter Title on Mobile' },
      { name: 'titleText', type: 'string', size: 'full', text: 'Title Text' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'titleMargin', type: 'string', size: 'small', text: 'Title Margin' },
      { name: 'titleTextAlign', type: 'string', size: 'small', text: 'Title Text Align' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'breakPoint', type: 'string', size: 'small', text: 'Breakpoint (sm or md)' },
      { name: 'wrapperBg', type: 'color', size: 'small', text: 'Background' },
      { name: 'wrapperPaddingBottom', type: 'string', size: 'small', text: 'Padding Bottom' },
      { name: 'filterBackground', type: 'color', size: 'small', text: 'Filter BG' },
      { name: 'filterIconFontSize', type: 'color', size: 'small', text: 'Filter Icon Font Size' },
      { name: 'filterChipColor', type: 'color', size: 'small', text: 'Filter Urgency Color' },
      { name: 'filterChipBg', type: 'color', size: 'small', text: 'Filter Urgency BG' },
      { name: 'filterChipThreshold', type: 'color', size: 'small', text: 'Filter Urgency Threshold' },
      { name: 'amenitiesType', type: 'string', size: 'small', text: 'Amenities type (icon or text)' },
      { name: 'amenitiesIconWidth', type: 'string', size: 'small', text: 'Amenities Icons Width' },
      { name: 'amenitiesIconMargin', type: 'string', size: 'small', text: 'Amenities Icon Margin' },
      { name: 'priceFontSize', type: 'string', size: 'small', text: 'Price font size' },
      { name: 'priceOldRateFontSize', type: 'string', size: 'small', text: 'Price Font Size' },
      { name: 'priceDiscountFontSize', type: 'string', size: 'small', text: 'Discount Price Font Size' },
      { name: 'priceOldRateColor', type: 'color', size: 'small', text: 'Discount Rate Color' },
      { name: 'initialSortSize', type: 'string', size: 'small', text: 'Initial Sort Size (sm, md, park etc)' },
    ],
    textOnly: [
      { name: 'ctaText', text: 'Call to Action Text', type: 'string', size: 'small' }
    ],
    version3: [
      { name: 'discountColor', text: 'Discount Color', type: 'color', size: 'small' },
      { name: 'checkoutSidebarColor', text: 'Checkout Sidebar Color', type: 'color', size: 'small' },
      { name: 'locationBoxPhoneLinkColor', text: 'Location Box Link Color', type: 'color', size: 'small' },
      { name: 'locationBoxHeaderColor', text: 'Location Box Header Color', type: 'color', size: 'small' },
      { name: 'locationBoxSubheaderColor', text: 'Location Box Subheader Color', type: 'color', size: 'small' },
      { name: 'viewUnitsChipBackground', text: 'View Units Chip BG', type: 'color', size: 'small' },
      { name: 'viewUnitsChipColor', text: 'View Units Chip Color', type: 'color', size: 'small' },
      /* { name: 'lazyLoadUnits', type: 'boolean', size: 'small', text: 'Lazy Load Units' },
      { name: 'small', type: 'boolean', size: 'small', text: 'Always use mobile styles' },
      { name: 'priceShowBorder', type: 'boolean', size: 'small', text: 'Show Border around Price' },
      { name: 'filterShowIcons', type: 'boolean', size: 'small', text: 'Filter Show Icons' },
      { name: 'smallSettingsFilterTitleFullText', type: 'boolean', size: 'small', text: 'Show Full Filter Title on Mobile' },*/
      { name: 'titleText', type: 'string', size: 'full', text: 'Title Text' },
      /*   { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
        { name: 'titleMargin', type: 'string', size: 'small', text: 'Title Margin' },
        { name: 'titleTextAlign', type: 'string', size: 'small', text: 'Title Text Align' },
        { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' }, */
      { name: 'breakPoint', type: 'string', size: 'small', text: 'Breakpoint (sm or md)' },
      { name: 'wrapperBg', type: 'color', size: 'small', text: 'Background' },
      /*  { name: 'wrapperPaddingBottom', type: 'string', size: 'small', text: 'Padding Bottom' }, */
      { name: 'filterBackground', type: 'color', size: 'small', text: 'Filter BG' },
      /*  { name: 'filterIconFontSize', type: 'color', size: 'small', text: 'Filter Icon Font Size' }, */
      { name: 'filterChipColor', type: 'color', size: 'small', text: 'Filter Urgency Color' },
      { name: 'filterChipBg', type: 'color', size: 'small', text: 'Filter Urgency BG' },
      { name: 'filterChipThreshold', type: 'color', size: 'small', text: 'Filter Urgency Threshold' },
      { name: 'amenitiesType', type: 'string', size: 'small', text: 'Amenities type (icon or text)' },
      /* { name: 'amenitiesIconWidth', type: 'string', size: 'small', text: 'Amenities Icons Width' },
      { name: 'amenitiesIconMargin', type: 'string', size: 'small', text: 'Amenities Icon Margin' },
      { name: 'priceFontSize', type: 'string', size: 'small', text: 'Price font size' },
      { name: 'priceOldRateFontSize', type: 'string', size: 'small', text: 'Price Font Size' },
      { name: 'priceDiscountFontSize', type: 'string', size: 'small', text: 'Discount Price Font Size' },
      { name: 'priceOldRateColor', type: 'color', size: 'small', text: 'Discount Rate Color' },
      { name: 'initialSortSize', type: 'string', size: 'small', text: 'Initial Sort Size (sm, md, park etc)' },
      { name: 'remainderColor', type: 'color', size: 'small', text: 'Remainder Text Color' }, */
      { name: 'bottomBGColor', type: 'string', size: 'full', text: 'Bottom Background' },
      /*   { name: 'bottomTitlesColor', type: 'color', size: 'small', text: 'Bottom Titles Text Color' },
        { name: 'bottomTitlesSize', type: 'string', size: 'small', text: 'Bottom Titles Text Size' },
        { name: 'borderBottomColor', type: 'string', size: 'small', text: 'Border Under Titles Color (ie. 3px solid #ffffff)' }, */
    ]
  };

  viewAllUnitsComponentDataOld = {
    version3: [
      { name: 'lazyLoadUnits', type: 'boolean', size: 'small', text: 'Lazy Load Units' },
      { name: 'small', type: 'boolean', size: 'small', text: 'Always use mobile styles' },
      { name: 'priceShowBorder', type: 'boolean', size: 'small', text: 'Show Border around Price' },
      { name: 'filterShowIcons', type: 'boolean', size: 'small', text: 'Filter Show Icons' },
      { name: 'smallSettingsFilterTitleFullText', type: 'boolean', size: 'small', text: 'Show Full Filter Title on Mobile' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'titleMargin', type: 'string', size: 'small', text: 'Title Margin' },
      { name: 'titleTextAlign', type: 'string', size: 'small', text: 'Title Text Align' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'wrapperPaddingBottom', type: 'string', size: 'small', text: 'Padding Bottom' },
      { name: 'filterIconFontSize', type: 'color', size: 'small', text: 'Filter Icon Font Size' },

      { name: 'amenitiesIconWidth', type: 'string', size: 'small', text: 'Amenities Icons Width' },
      { name: 'amenitiesIconMargin', type: 'string', size: 'small', text: 'Amenities Icon Margin' },
      { name: 'priceFontSize', type: 'string', size: 'small', text: 'Price font size' },
      { name: 'priceOldRateFontSize', type: 'string', size: 'small', text: 'Price Font Size' },
      { name: 'priceDiscountFontSize', type: 'string', size: 'small', text: 'Discount Price Font Size' },
      { name: 'priceOldRateColor', type: 'color', size: 'small', text: 'Discount Rate Color' },
      { name: 'initialSortSize', type: 'string', size: 'small', text: 'Initial Sort Size (sm, md, park etc)' },
      { name: 'remainderColor', type: 'color', size: 'small', text: 'Remainder Text Color' },

      { name: 'bottomTitlesColor', type: 'color', size: 'small', text: 'Bottom Titles Text Color' },
      { name: 'bottomTitlesSize', type: 'string', size: 'small', text: 'Bottom Titles Text Size' },
      { name: 'borderBottomColor', type: 'string', size: 'small', text: 'Border Under Titles Color (ie. 3px solid #ffffff)' },
    ]
  }

  comingSoonComponentData = {
    original: [
      { name: 'backgroundColor', type: 'color', size: 'small', text: 'Background Color' },
    ]
  };

  customPageHeroDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },

      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };
  customPageHeroData = {
    original: [
      /*       { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
            { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
            { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
            { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
            { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
            { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
             { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };


  aboutUsHeroData = {
    original: [
      /*       { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
            { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
            { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
            { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
            { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*       { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
            { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
            { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle' },
      /* { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
    ]
  };
  aboutUsHeroDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
      { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' },
    ]
  };


  aboutUsMainSectionData = {
    original: [
      { name: 'useSlider', type: 'boolean', size: 'small', text: 'Use slider for About Us page' }
    ],
    rows: [
      /*  { name: 'containerClass', type: 'selection', size: 'full', text: 'Container Class', options: [{ value: 'container', label: 'container' }, { value: 'container-fluid', label: 'container-fluid' }] } */
    ]
  };
  aboutUsMainSectionDataOld = {
    rows: [
      { name: 'containerClass', type: 'selection', size: 'full', text: 'Container Class', options: [{ value: 'container', label: 'container' }, { value: 'container-fluid', label: 'container-fluid' }] }
    ]
  };

  viewAllReviewsHeaderData = {
    original: [
      /*  { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
       { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
       { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
       { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
       { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*       { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
            { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
            { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  viewAllReviewsHeaderDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  storeLocatorHeaderData = {
    original: [
      /*       { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
            { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
            { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
            { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
            { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*  { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
       { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      /*       { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  storeLocatorHeaderDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  storageCalculatorHeaderData = {
    original: [
      /*       { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
            { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
            { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
            { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
            { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*  { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
       { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle' },
      /*       { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  storageCalculatorHeaderDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  storageTipsHeaderData = {
    original: [
      /*  { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
       { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
       { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
       { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
       { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /* { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle' },
      /*       { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  storageTipsHeaderDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  storageTipsBodyData = {
    original: [{ name: 'showTipsBlurb', type: 'boolean', size: 'small', text: 'Show blurb?' },
    { name: 'blurbTipsPlacement', type: 'selection', size: 'small', text: 'Blurb Placement (left hides right faqs column)', options: [{ value: 'top', label: 'Top' }, { value: 'bottom', label: 'Bottom' }, { value: 'left', label: 'Left' }] }],
    dropdowns: [
      { name: 'fontSize', text: 'Storage Tip Body Font Size', type: 'string', size: 'small' },
      { name: 'titleFontSize', text: 'Storage Tip Title Font Size', type: 'string', size: 'small' },
      { name: 'titleColor', text: 'Storage Tip Title Color', type: 'color', size: 'small' },
      { name: 'titleUnderlineColor', text: 'Storage Tip Title Underline Color', type: 'color', size: 'small' },
      { name: 'selectedTitleColor', text: 'Selected Storage Tip title color', type: 'color', size: 'small' },
      { name: 'selectedTitleUnderlineColor', text: 'Selected Storage Tip Title Underline Color', type: 'color', size: 'small' },
      { name: 'showTipsBlurb', type: 'boolean', size: 'small', text: 'Show blurb?' },
      { name: 'blurbTipsPlacement', type: 'selection', size: 'small', text: 'Blurb Placement (left hides right faqs column)', options: [{ value: 'top', label: 'Top' }, { value: 'bottom', label: 'Bottom' }, { value: 'left', label: 'Left' }] }
    ],
    cards: [
      { name: 'fontSize', text: 'Tip Body Font Size', type: 'string', size: 'small' },
      { name: 'titleFontSize', text: 'Tip Title Font Size', type: 'string', size: 'small' },
      { name: 'titleColor', text: 'Tip Title Color', type: 'color', size: 'small' },
      { name: 'selectedTitleColor', text: 'Selected Tip title color', type: 'color', size: 'small' },
      { name: 'selectedTitleBackgroundColor', text: 'Selected Tip Title Border Left Color', type: 'color', size: 'small' },
      { name: 'showTipsBlurb', type: 'boolean', size: 'small', text: 'Show blurb?' },
      { name: 'blurbTipsPlacement', type: 'selection', size: 'small', text: 'Blurb Placement (left hides right faqs column)', options: [{ value: 'top', label: 'Top' }, { value: 'bottom', label: 'Bottom' }, { value: 'left', label: 'Left' }] }
    ]
  };

  contactHeaderData = {
    original: [
      /*       { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
            { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
            { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
            { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
            { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*       { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
            { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      /*       { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  contactHeaderDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  generalInfoHeaderData = {
    original: [
      /* { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*   { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
        { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      /*       { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  generalInfoHeaderDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  generalInfoMainSectionData = {
    original: [
      { name: 'tabColor', text: 'Tab Text Color', type: 'color', size: 'small' },
      { name: 'tabBackgroundColor', text: 'Tab Background Color', type: 'color', size: 'small' },
      { name: 'tabHoverColor', text: 'Tab Text Hover Color', type: 'color', size: 'small' },
      { name: 'tabHoverBackgroundColor', text: 'Tab Hover Background Color', type: 'color', size: 'small' },
      { name: 'tabActiveColor', text: 'Selected Tab Text Color', type: 'color', size: 'small' },
      { name: 'tabActiveBackgroundColor', text: 'Selected Tab Background Color', type: 'color', size: 'small' },
      { name: 'mobileTabColor', text: 'Tab Text Color (Mobile)', type: 'color', size: 'small' },
      { name: 'mobileTabBackgroundColor', text: 'Tab Background Color (Mobile)', type: 'color', size: 'small' },
      { name: 'mobileTabHoverColor', text: 'Tab Text Hover Color (Mobile)', type: 'color', size: 'small' },
      { name: 'mobileTabHoverBackgroundColor', text: 'Tab Hover Background Color (Mobile)', type: 'color', size: 'small' },
      { name: 'mobileTabActiveColor', text: 'Selected Tab Text Color (Mobile)', type: 'color', size: 'small' },
      { name: 'mobileTabActiveBackgroundColor', text: 'Selected Tab Background Color (Mobile)', type: 'color', size: 'small' },
    ]
  };

  faqsHeaderData = {
    original: [
      /*   { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
        { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
        { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
        { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
        { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /*  { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
       { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      /*       { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  faqsHeaderDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  faqsMainSectionData = {
    original: [
      { name: 'fontSize', text: 'Faq Body Font Size', type: 'string', size: 'small' },
      { name: 'titleFontSize', text: 'Faq Title Font Size', type: 'string', size: 'small' },
      { name: 'titleColor', text: 'Faq Title Color', type: 'color', size: 'small' },
      { name: 'selectedTitleColor', text: 'Selected Faq title color', type: 'color', size: 'small' },
      { name: 'selectedTitleBackgroundColor', text: 'Selected Faq Title Border Left Color', type: 'color', size: 'small' },
      { name: 'showBlurb', type: 'boolean', size: 'small', text: 'Show blurb?' },
      { name: 'blurbPlacement', type: 'selection', size: 'small', text: 'Blurb Placement (left hides right faqs column)', options: [{ value: 'top', label: 'Top' }, { value: 'bottom', label: 'Bottom' }, { value: 'left', label: 'Left' }] }
    ]
  };

  locationBarStyleData = {
    original: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      /*       { name: 'height', type: 'string', size: 'small', text: 'Height' },
            { name: 'background', type: 'color', size: 'small', text: 'Background' },
            { name: 'color', type: 'color', size: 'small', text: 'Color' },
            { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
            { name: 'highlightColor', type: 'color', size: 'small', text: 'Hover Color' },
            { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' }, */
    ],
    facility: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      { name: 'showChangeLocationButton', type: 'boolean', size: 'small', text: 'Show choose location button?' },
      /*   { name: 'height', type: 'string', size: 'small', text: 'Height' },
        { name: 'background', type: 'color', size: 'small', text: 'Background' },
        { name: 'color', type: 'color', size: 'small', text: 'Color' },
        { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
        { name: 'highlightColor', type: 'color', size: 'small', text: 'Hover Color' },
        { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' }, */
    ],
    withLocations: [
      /*       { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' }, */
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      /*       { name: 'centerLocationLinks', type: 'boolean', size: 'small', text: 'Center Location Links?' },
            { name: 'height', type: 'string', size: 'small', text: 'Height' },
            { name: 'background', type: 'color', size: 'small', text: 'Background' },
            { name: 'color', type: 'color', size: 'small', text: 'Color' },
            { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
            { name: 'highlightColor', type: 'color', size: 'small', text: 'Hover Color' },
            { name: 'selectedLocationColor', type: 'color', size: 'small', text: 'Selected Location Color' },
            { name: 'selectedLocationTextDecoration', type: 'string', size: 'small', text: 'Selected Location Text Decoration' }, */
    ]
  };
  locationBarStyleDataOld = {
    original: [
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
      { name: 'highlightColor', type: 'color', size: 'small', text: 'Hover Color' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
    ],
    facility: [
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
      { name: 'highlightColor', type: 'color', size: 'small', text: 'Hover Color' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
    ],
    withLocations: [
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
      { name: 'centerLocationLinks', type: 'boolean', size: 'small', text: 'Center Location Links?' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'linkColor', type: 'color', size: 'small', text: 'Link Color' },
      { name: 'highlightColor', type: 'color', size: 'small', text: 'Hover Color' },
      { name: 'selectedLocationColor', type: 'color', size: 'small', text: 'Selected Location Color' },
      { name: 'selectedLocationTextDecoration', type: 'string', size: 'small', text: 'Selected Location Text Decoration' },
    ]
  };

  homePageFeaturesComponentData = {
    original: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      { name: 'title', type: 'string', size: 'full', text: 'Title' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'showTitle', type: 'boolean', size: 'small', text: 'Show title?' },
      { name: 'uppercase', type: 'boolean', size: 'small', text: 'Font uppercase?' },
      { name: 'showCircles', type: 'boolean', size: 'small', text: 'Show Circles?' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'backColor', type: 'color', size: 'small', text: 'Back Text Color' },
      { name: 'circleBackground', type: 'color', size: 'small', text: 'Circle Background' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
    ],
    originalWithOuterCircle: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      { name: 'title', type: 'string', size: 'full', text: 'Title' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      { name: 'showTitle', type: 'boolean', size: 'small', text: 'Show title?' },
      { name: 'uppercase', type: 'boolean', size: 'small', text: 'Font uppercase?' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'circleBackground', type: 'color', size: 'small', text: 'Circle Background' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
    ],
    svg: [
      { name: 'featureIconColor', type: 'color', size: 'small', text: 'Feature Icon Color' },
      { name: 'featureIconBackgroundColor', type: 'color', size: 'small', text: 'Feature Icon Background/Secondary Color' },
      { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
      /* { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'circleBackground', type: 'color', size: 'small', text: 'Circle Background' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'size', type: 'string', size: 'small', text: 'Height/Width (px)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      { name: 'subtitle', type: 'string', size: 'small', text: 'Subtitle' },
      /* { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' }, */
      { name: 'showTitle', type: 'boolean', size: 'small', text: 'Show title?' },
      /*  { name: 'showCircles', type: 'boolean', size: 'small', text: 'Show Circles?' }, */
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
    ],
  };
  homePageFeaturesComponentDataOld = {

    svg: [
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'circleBackground', type: 'color', size: 'small', text: 'Circle Background' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'size', type: 'string', size: 'small', text: 'Height/Width (px)' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
      { name: 'showCircles', type: 'boolean', size: 'small', text: 'Show Circles?' },
    ],
  };

  homePageButtonComponentData = {
    original: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'buttonBackground', type: 'color', size: 'small', text: 'Button Background' },
      { name: 'buttonColor', type: 'color', size: 'small', text: 'Button Color' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'buttonWidth', type: 'string', size: 'small', text: 'Button Width' },
      { name: 'buttonFontSize', type: 'string', size: 'small', text: 'Button Font Size' },
      { name: 'buttonPadding', type: 'string', size: 'small', text: 'Button Padding' },
      { name: 'usePayBillButton', type: 'boolean', size: 'small', text: 'Pay Bill instead of Contact' },
      { name: 'leftButtonText', type: 'string', size: 'small', text: 'Left Button Text' },
      { name: 'leftButtonLink', type: 'string', size: 'small', text: 'Left Button Link' },
      { name: 'rightButtonText', type: 'string', size: 'small', text: 'Right Button Text' },
      { name: 'rightButtonLink', type: 'string', size: 'small', text: 'Right Button Link' }

    ],
    withPicture: [
      { name: 'hideContactUsButton', type: 'boolean', size: 'small', text: 'Hide Contact Us button?' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'buttonBackground', type: 'color', size: 'small', text: 'Button Background' },
      { name: 'buttonColor', type: 'color', size: 'small', text: 'Button Color' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'buttonWidth', type: 'string', size: 'small', text: 'Button Width' },
      { name: 'buttonFontSize', type: 'string', size: 'small', text: 'Button Font Size' },
      { name: 'buttonPadding', type: 'string', size: 'small', text: 'Button Padding' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'textFontSize', type: 'string', size: 'small', text: 'Text Font Size' },
      { name: 'title', type: 'string', size: 'full', text: 'Title' },
      { name: 'text', type: 'string', size: 'full', text: 'Text' },
      { name: 'ctaUrl', type: 'string', size: 'full', text: 'Image URL' },
      { name: 'leftButtonText', type: 'string', size: 'small', text: 'Left Button Text' },
      { name: 'leftButtonLink', type: 'string', size: 'small', text: 'Left Button Link' },
      { name: 'rightButtonText', type: 'string', size: 'small', text: 'Right Button Text' },
      { name: 'rightButtonLink', type: 'string', size: 'small', text: 'Right Button Link' }
    ]
  };
  homePageButtonComponentDataOld = {
    original: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'buttonBackground', type: 'color', size: 'small', text: 'Button Background' },
      { name: 'buttonColor', type: 'color', size: 'small', text: 'Button Color' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'buttonWidth', type: 'string', size: 'small', text: 'Button Width' },
      { name: 'buttonFontSize', type: 'string', size: 'small', text: 'Button Font Size' },
      { name: 'buttonPadding', type: 'string', size: 'small', text: 'Button Padding' },
      { name: 'usePayBillButton', type: 'boolean', size: 'small', text: 'Pay Bill instead of Contact' },
    ]
  };

  homePageMainIconsComponentData = {
    original: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'minHeight', type: 'string', size: 'small', text: 'Min Height' },
      { name: 'iconMaxWidth', type: 'string', size: 'small', text: 'Icon Max Width' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'textFontSize', type: 'string', size: 'small', text: 'Text Font Size' },
    ],
    withBoxes: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      { name: 'showBoxShadow', type: 'boolean', size: 'small', text: 'Show shading on Boxes?' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'minHeight', type: 'string', size: 'small', text: 'Min Height' },
      { name: 'iconMaxWidth', type: 'string', size: 'small', text: 'Icon Max Width' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'textFontSize', type: 'string', size: 'small', text: 'Text Font Size' },
      { name: 'boxBackground', type: 'color', size: 'small', text: 'Box Background' },
      { name: 'paddingAboveTitle', type: 'string', size: 'small', text: 'Padding above Title' },
    ],
    svg: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show material design shading?' },
      { name: 'showBoxShadow', type: 'boolean', size: 'small', text: 'Show shading on Boxes?' },
      { name: 'showBoxes', type: 'boolean', size: 'small', text: 'Show Boxes?' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'minHeight', type: 'string', size: 'small', text: 'Min Height' },
      { name: 'titleFontSize', type: 'string', size: 'small', text: 'Title Font Size' },
      { name: 'textFontSize', type: 'string', size: 'small', text: 'Text Font Size' },
      { name: 'boxBackground', type: 'color', size: 'small', text: 'Box Background' },
      { name: 'featureIconColor', type: 'color', size: 'small', text: 'Feature Icon Color' },
      { name: 'featureIconBackgroundColor', type: 'color', size: 'small', text: 'Feature Icon Background Color' },
      { name: 'size', type: 'string', size: 'small', text: 'Height/Width (px)' },
    ],
    v3: [
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      /*   { name: 'boxBackground', type: 'color', size: 'small', text: 'Box Background' },
        { name: 'size', type: 'string', size: 'small', text: 'Height/Width (px)' },
        { name: 'color', type: 'color', size: 'small', text: 'Color' }, */
      { name: 'featureIconColor', type: 'color', size: 'small', text: 'Feature Icon Color' },
      { name: 'featureIconBackgroundColor', type: 'color', size: 'small', text: 'Feature Icon Background Color' },
    ]
  };

  homePageMainIconsComponentDataOld = {
    v3: [
      { name: 'boxBackground', type: 'color', size: 'small', text: 'Box Background' },
      { name: 'size', type: 'string', size: 'small', text: 'Height/Width (px)' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
    ]
  };

  mainNavBarStyleData = {
    stickyOriginal: [
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show Material Design Shading?' },
      { name: 'mattStyle', type: 'boolean', size: 'small', text: 'Matt style dropdowns?' },
      /*  { name: 'showLogo', type: 'boolean', size: 'small', text: 'Show logo?' }, */
      { name: 'showUserAccount', type: 'boolean', size: 'small', text: 'Show User Account?' },
      /* { name: 'showLocationName', type: 'boolean', size: 'small', text: 'Show Location Name next to Logo' }, */
      { name: 'smHamburger', type: 'boolean', size: 'small', text: 'Hamburger on sm instead of xs' },
      { name: 'mdHamburger', type: 'boolean', size: 'small', text: 'Hamburger on md instead of xs' },
      /* { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'hamburgerColor', type: 'color', size: 'small', text: 'Hamburger Color' },
      { name: 'logoHeight', type: 'string', size: 'small', text: 'Logo Height' },
      { name: 'logoWidth', type: 'string', size: 'small', text: 'Logo Width' },
      { name: 'logoMarginTop', type: 'string', size: 'small', text: 'Logo Margin Top' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' }, */
    ],
    stickyNavWithPayBill: [
      { name: 'payBillText', type: 'string', size: 'small', text: 'Pay Bill Text' },
      { name: 'mattStyle', type: 'boolean', size: 'small', text: 'Matt style dropdowns?' },
      { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show Material Design Shading?' },
      /* { name: 'showLogo', type: 'boolean', size: 'small', text: 'Show logo?' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'hamburgerColor', type: 'color', size: 'small', text: 'Hamburger Color' },
      { name: 'payBillColor', type: 'color', size: 'small', text: 'Pay Bill Button Color' },
      { name: 'payBillBackground', type: 'color', size: 'small', text: 'Pay Bill Button Background' },
      { name: 'payBillBorder', type: 'color', size: 'small', text: 'Pay Bill Button Border' },
      { name: 'logoHeight', type: 'string', size: 'small', text: 'Logo Height' },
      { name: 'logoWidth', type: 'string', size: 'small', text: 'Logo Width' },
      { name: 'logoMarginTop', type: 'string', size: 'small', text: 'Logo Margin Top' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' }, */
      { name: 'smHamburger', type: 'boolean', size: 'small', text: 'Hamburger on sm instead of xs' },
      /* { name: 'activePayBillButton', type: 'boolean', size: 'small', text: 'Active Pay Bill Button' }, */
    ],
    /*     navWithPayBillCentered: [
          { name: 'showMaterialDesignShading', type: 'boolean', size: 'small', text: 'Show Material Design Shading?' },
          { name: 'mattStyle', type: 'boolean', size: 'small', text: 'Matt style dropdowns?' },
          { name: 'height', type: 'string', size: 'small', text: 'Height' },
          { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
          { name: 'color', type: 'color', size: 'small', text: 'Color' },
          { name: 'hamburgerColor', type: 'color', size: 'small', text: 'Hamburger Color' },
          { name: 'payBillColor', type: 'color', size: 'small', text: 'Pay Bill Button Color' },
          { name: 'payBillBackground', type: 'color', size: 'small', text: 'Pay Bill Button Background' },
          { name: 'payBillBorder', type: 'color', size: 'small', text: 'Pay Bill Button Border' },
          { name: 'background', type: 'color', size: 'small', text: 'Background' },
          { name: 'smHamburger', type: 'boolean', size: 'small', text: 'Hamburger on sm instead of xs' },
          { name: 'activePayBillButton', type: 'boolean', size: 'small', text: 'Active Pay Bill Button' },
        ] */
  };
  mainNavBarStyleDataOld = {
    stickyOriginal: [
      { name: 'showLogo', type: 'boolean', size: 'small', text: 'Show logo?' },
      // { name: 'showLocationName', type: 'boolean', size: 'small', text: 'Show Location Name next to Logo' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'hamburgerColor', type: 'color', size: 'small', text: 'Hamburger Color' },
      { name: 'logoHeight', type: 'string', size: 'small', text: 'Logo Height' },
      { name: 'logoWidth', type: 'string', size: 'small', text: 'Logo Width' },
      { name: 'logoMarginTop', type: 'string', size: 'small', text: 'Logo Margin Top' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
    ],
    stickyNavWithPayBill: [
      { name: 'showLogo', type: 'boolean', size: 'small', text: 'Show logo?' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'hamburgerColor', type: 'color', size: 'small', text: 'Hamburger Color' },
      { name: 'payBillColor', type: 'color', size: 'small', text: 'Pay Bill Button Color' },
      { name: 'payBillBackground', type: 'color', size: 'small', text: 'Pay Bill Button Background' },
      { name: 'payBillBorder', type: 'color', size: 'small', text: 'Pay Bill Button Border' },
      { name: 'logoHeight', type: 'string', size: 'small', text: 'Logo Height' },
      { name: 'logoWidth', type: 'string', size: 'small', text: 'Logo Width' },
      { name: 'logoMarginTop', type: 'string', size: 'small', text: 'Logo Margin Top' },
      { name: 'background', type: 'color', size: 'small', text: 'Background' },
      { name: 'activePayBillButton', type: 'boolean', size: 'small', text: 'Active Pay Bill Button' },
    ]
  };

  sizeGuideHeroData = {
    original: [
      /*       { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
            { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
            { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
            { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
            { name: 'height', type: 'string', size: 'small', text: 'Height' }, */
      { name: 'background', type: 'string', size: 'full', text: 'Background' },
      /* { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' }, */
      { name: 'title', type: 'string', size: 'small', text: 'Title' },
      /*       { name: 'color', text: 'Title Color', type: 'color', size: 'small' }, */
    ]
  };
  sizeGuideHeroDataOld = {
    original: [
      { name: 'useCard', type: 'boolean', size: 'small', text: 'Show card behind title' },
      { name: 'cardBackground', text: 'Card background, if any', type: 'color', size: 'small' },
      { name: 'cardBorderRadius', text: 'Card border radius, if any', type: 'string', size: 'small' },
      { name: 'cardPadding', text: 'Card padding, if any', type: 'string', size: 'small' },
      { name: 'height', type: 'string', size: 'small', text: 'Height' },
      { name: 'backgroundSize', type: 'string', size: 'full', text: 'Background Size' },
      { name: 'fontWeight', type: 'string', size: 'full', text: 'Font Weight (Default 200)' },
      { name: 'color', text: 'Title Color', type: 'color', size: 'small' },
    ]
  };

  sizeGuideMainSectionData = {
    original: [
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'sideButtonColor', type: 'color', size: 'small', text: 'Side Button Color' },
      { name: 'sideButtonSelectedColor', type: 'color', size: 'small', text: 'Side Button Selected Color' },
      { name: 'sideButtonSelectedBackgroundColor', type: 'color', size: 'small', text: 'Side Button Selected Background Color' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
    ],
    version2: [
      { name: 'color', type: 'color', size: 'small', text: 'Color' },
      { name: 'sideButtonColor', type: 'color', size: 'small', text: 'Side Button Color' },
      { name: 'fontSize', type: 'string', size: 'small', text: 'Font Size' },
    ]
  };

  portalLoginData = {
    simple: [
      { name: 'simpleLogoUrl', type: 'string', size: 'full', text: 'Logo' },
      /* { name: 'logoWidth', type: 'string', size: 'small', text: 'Logo Width' }, */
    ],
    withImage: [
      { name: 'backgroundImageUrl', type: 'string', size: 'full', text: 'Background' },
      { name: 'formBackground', type: 'string', size: 'full', text: 'Form Background' },
      { name: 'formColor', type: 'color', size: 'small', text: 'Form Color' },
      { name: 'existingCustomersColor', type: 'color', size: 'small', text: 'Existing Customers Text Color' },
      { name: 'existingCustomersButtonColor', type: 'color', size: 'small', text: 'Existing Customers Button Color' },
      { name: 'locationColor', type: 'color', size: 'small', text: 'Location Color' },
      { name: 'logoWidth', type: 'string', size: 'small', text: 'Logo Width' },
      { name: 'hideLogo', type: 'boolean', size: 'small', text: 'Hide Logo' },
      { name: 'showChangeLocationButton', type: 'boolean', size: 'small', text: 'Show Change Location Button' },
    ]
  };
  portalLoginDataOld = {
    simple: [
      { name: 'logoWidth', type: 'string', size: 'small', text: 'Logo Width' },
    ]
  };

  googleMapData = {
    original: [
      { name: 'mapHeight', type: 'string', size: 'small', text: 'Map Height' },
      /* { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' }, */
      { name: 'hideEmail', type: 'boolean', size: 'full', text: 'Hide Email From Info Box' },
      { name: 'zoomToLocation', type: 'boolean', size: 'full', text: 'Zoom to selected location where possible' },
      /* { name: 'useSnazzyWindows', type: 'boolean', size: 'full', text: 'Use Snazzy Maps windows' },
      { name: 'showCloseButton', type: 'boolean', size: 'full', text: 'Show Close Button (Snazzy only)' },
      { name: 'windowPlacement', type: 'selection', size: 'small', text: 'Window Placement (Snazzy only)', options: [{ value: 'right', label: 'Right' }, { value: 'top', label: 'Top' }] },
      { name: 'borderRadius', type: 'string', size: 'small', text: 'Window Border Radius (Snazzy only)' }, */
    ]
  };
  googleMapDataOld = {
    original: [
      { name: 'showLocationName', type: 'boolean', size: 'full', text: 'Show Location Name instead of Client Name' },
      { name: 'useSnazzyWindows', type: 'boolean', size: 'full', text: 'Use Snazzy Maps windows' },
      { name: 'showCloseButton', type: 'boolean', size: 'full', text: 'Show Close Button (Snazzy only)' },
      { name: 'windowPlacement', type: 'selection', size: 'small', text: 'Window Placement (Snazzy only)', options: [{ value: 'right', label: 'Right' }, { value: 'top', label: 'Top' }] },
      { name: 'borderRadius', type: 'string', size: 'small', text: 'Window Border Radius (Snazzy only)' },
    ]
  };

  storeLocatorData = {
    original: [
      { name: 'showCloseButton', type: 'boolean', size: 'full', text: 'Show Close Button on Windows' },
      { name: 'showSearchBarOnHomePage', type: 'boolean', size: 'full', text: 'Show Search Bar on Home Page' },
      { name: 'autofill', type: 'boolean', size: 'full', text: 'Autofill with location on homepage' },
      { name: 'panelMode', type: 'boolean', size: 'full', text: 'Use floating panels instead of snazzy info windows for map markers' },
      { name: 'windowPlacement', type: 'selection', size: 'small', text: 'Window Placement', options: [{ value: 'right', label: 'Right' }, { value: 'top', label: 'Top' }] },
      { name: 'borderRadius', type: 'string', size: 'small', text: 'Window Border Radius' },
      { name: 'closestStoreRibbonColor', type: 'color', size: 'small', text: 'Closest Store Ribbon Color' },
      { name: 'closestStoreRibbonBackgroundColor', type: 'color', size: 'small', text: 'Closest Store Ribbon Background Color' },
      { name: 'selectedStoreRibbonColor', type: 'color', size: 'small', text: 'Selected Store Ribbon Color' },
      { name: 'selectedStoreRibbonBackgroundColor', type: 'color', size: 'small', text: 'Selected Store Ribbon Background Color' },
    ]
  };

  constructor() {
    for (let item of this.oldArray) {
      this.tmp[item] = _.cloneDeep(this[item]);
    }
  }

  toggleSettings() {
    this.isVisible = !this.isVisible;
    if (this.isVisible) {
      for (let item of this.oldArray) {
        for (let key in this[item]) {
          this[item][key] = _.concat(this.tmp[item][key], this[`${ item }Old`][key]);
        }
      }
    }
    else {
      for (let item of this.oldArray) {
        this[item] = _.cloneDeep(this.tmp[item]);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/client-settings.ts